import { render } from "./ForumCommentCard.vue?vue&type=template&id=cbb74bca"
import script from "./ForumCommentCard.vue?vue&type=script&lang=js"
export * from "./ForumCommentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__